import { Component, State, Prop, h, Fragment, Element } from '@stencil/core';
export class FormatString {
  constructor() {
    this.version = '0.1.3';
  }
  /**
   * Adds padding and newlines into a string without whitespace
   * @param {str} str The str to be modified (any whitespace will be stripped)
   * @param {int} spaceEvery number of characters before inserting a space
   * @param {int} wrapeEvery number of spaces before using a newline instead
   * return {string} The replaced string
   */
  addPadding(str, spaceEvery, wrapEvery) {
    var regex = new RegExp('.{' + spaceEvery + '}', 'g');
    // Add space every {spaceEvery} chars, newline after {wrapEvery} spaces
    return str.replace(/[\n\s]/g, '').replace(regex, function (value, index) {
      // The index is the group that just finished
      var newlineIndex = spaceEvery * (wrapEvery - 1);
      return value + (index % (spaceEvery * wrapEvery) === newlineIndex ? '\n' : ' ');
    });
  }
  splitStringFromEnd(customString, every) {
    if (customString.length % every === 0) {
      return this.addPadding(customString, every, 1000);
    }
    else {
      const rest = customString.length % every;
      const mainpart = this.addPadding(customString.slice(rest), every, 1000);
      const begin = customString.slice(0, rest);
      return begin + ' ' + mainpart;
    }
  }
  format() {
    if (!this.slot)
      return;
    const stringGiven = this.slot.assignedNodes()[0].textContent;
    if (this.split) {
      this.formattedString = this.splitStringFromEnd(stringGiven, this.split);
    }
    else if (this.padding) {
      this.formattedString = this.addPadding(stringGiven, this.padding, 1000);
    }
    else {
      this.formattedString = stringGiven;
    }
  }
  componentDidLoad() {
    this.slot = this.el.shadowRoot.querySelector('slot');
    this.format();
    this.slot.addEventListener('slotchange', () => {
      this.format();
    });
  }
  render() {
    return (h(Fragment, null,
      h("span", null, this.formattedString),
      h("span", { hidden: true },
        h("slot", null))));
  }
  static get is() { return "c-format-string"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["styles.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["styles.css"]
  }; }
  static get properties() { return {
    "version": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'0.1.3'"
    },
    "padding": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "padding",
      "reflect": false
    },
    "split": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "split",
      "reflect": false
    }
  }; }
  static get states() { return {
    "formattedString": {}
  }; }
  static get elementRef() { return "el"; }
}
